import { PALETTE } from "../../../../common/styles/palette"

export const styles = (theme: any) => {
    return {
        root: {
            paddingRight: '0px',
            display: 'flex',
            justifyContent: 'center'
        },
        rootPurchased: {
            paddingLeft: '0px',
            // display: 'content',
        },
        typoPurchased: {
            fontSize: '12px',
            fontWeight: "bold" as 'bold',
            lineHeight: '20px',
        },
        imageContainer: {
            maxHeight: '140px',
            maxWidth: '140px',
        },
        image: {
            maxHeight: '140px',
            maxWidth: '140px',
        },
        nameSurnameContainer: {
            paddingRight: 10
        },
        blackColor: {
            color: PALETTE.UI.InputText.TextColor
        },
        bgRed: {
            backgroundColor: '#FF0000',
        },
        bgGreen: {
            backgroundColor: '#008000',
        },
        roomDotInfoContainer: {
            display: "flex",
            justifyContent: "center",
        },
        roomEnabled: {
            width: "15px",
            height: "15px",
            backgroundColor: 'green',
            borderRadius: "50%"
        },
        roomDisabled: {
            width: "15px",
            height: "15px",
            backgroundColor: '#FF0000',
            borderRadius: "50%"
        },
        roomExpired: {
            width: "15px",
            height: "15px",
            backgroundColor: '#FF0000',
            borderRadius: "50%"
        },
        contactReservationButton: {
            marginTop: '-15px',
            padding: "2px",
            width: '93%',
            marginBottom: '10px',
            fontSize: 'x-small',
            fontWeight: "bold" as 'bold',
        },
        contactInformationButton: {
            // marginTop: '-15px',
            padding: "2px",
            width: '93%',
            // marginBottom: '10px',
            fontSize: 'x-small',
            fontWeight: "bold" as 'bold',
        },
        contactReservationButtonContainer: {
            display: "flex",
            justifyContent: "center",
        },
        contactSubscriptionsButton: {
            marginTop: '-15px',
            padding: "2px",
            width: '93%',
            marginBottom: '10px',
            fontSize: 'x-small',
            fontWeight: "bold" as 'bold',
        },
        contactSubscriptionsButtonContainer: {
            display: "flex",
            justifyContent: "center",
        },
        cardNumberContainer: {
            display: "flex",
            alignItems: "center",
        },
        // GREEN PASS
        greenPassContainer: {
            display: "flex",
            alignItems: "center",
            backgroundColor: '#90ee90',
        },
        medicalFileContainer: {
            display: "block",
            alignItems: "center",
            backgroundColor: "#1d7b9b",//29c02d
            color: "white",
            padding: "5px",
            marginLeft: "-5px",
            width: "fit-content",
            // fontWeight: "normal",
        },
        blockAccess: {
            display: "flex",
            alignItems: "center",
            backgroundColor: '#FF0000',
            borderColor: 'red',
            borderStyle: 'solid',
            borderSize: '1px',
        },
        // PURCHASE
        isExpired: {
            backgroundColor: '#FF0000',
            color: '#FFF',
            borderBottom: '1px solid #fff'
        },
        isValid: {
            backgroundColor: '#90ee90',
            borderBottom: '1px solid #fff',
        },
        isNearExpiration: {
            backgroundColor: '#EAE307',
            borderBottom: '1px solid #fff',
        },
    }
}